import { connect } from "react-redux";
import * as actions from "./actions";

function mapStateToProps(state) {
  return { depot: state.depot };
}

function mapDispatchToProps(dispatch) {
  return {
    getDepot: (accountId) => {
      dispatch(actions.fetch_depot(accountId));
    },

    getBorrowerDepot: (accountId, depotId) => {
      dispatch(actions.fetch_borrower_depot(accountId, depotId));
    },

    transferMoneyToSavelendAccount: (identity, amount) => {
      dispatch(actions.transfer_money_to_savelend_depot(identity, amount));
    },

    addDepot: (accountId, depotName, currency) => {
      dispatch(actions.add_depot(accountId, depotName, currency));
    },
  };
}

export const userDepotConnector = connect(mapStateToProps, mapDispatchToProps);
